import React, { FC } from 'react'

import { useSelector } from 'react-redux'

import { Container } from '@material-ui/core'

import { Flexbox, Logo } from '~/components/shared'
import HeaderTabs from '~/components/tabs/HeaderTabs'

import { AppState } from '~/state/store'

import { useDesktopStyles } from './Header.styles'
import HeaderPopover from './HeaderPopover'

const HeaderDesktop: FC<HeaderProps> = ({
  incomingMessages,
  logged,
  logout
}) => {
  const s = useDesktopStyles()
  const uiSettings = useSelector((state: AppState) => state.user?.ui_setting)

  return (
    <header className={s.root}>
      <Container maxWidth="xl">
        <Flexbox className={s.container}>
          <Logo src={uiSettings?.logo_link} width={uiSettings?.logo_width} />

          {logged && (
            <>
              <HeaderTabs incomingMessages={incomingMessages} logged={logged} />
              <HeaderPopover logout={logout} />
            </>
          )}
        </Flexbox>
      </Container>
    </header>
  )
}

export default HeaderDesktop
